export const KioskLang = {
    wrongPassErr: 'رمز عبور وارد شده صحیح نیست. لطفا مجددا تلاش کنید',
    noInternet: 'از اتصال دستگاه به اینترنت جهت ارسال رمز عبور اطمینان حاصل فرمایید',
};
